// extracted by mini-css-extract-plugin
export default {"swiper":"Swiper_swiper__UaIBK"};